import { render, staticRenderFns } from "./passo6.vue?vue&type=template&id=3ba44c3b&"
import script from "./passo6.vue?vue&type=script&lang=js&"
export * from "./passo6.vue?vue&type=script&lang=js&"
import style0 from "./passo6.vue?vue&type=style&index=0&id=3ba44c3b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports